import React from "react";

interface CardProps {
  image: string;
  title?: string; // Optional title prop
  description: string;
  gradient?: "default" | "alternative"; // Gradient prop with two options
  dataAos?: string; // Optional AOS animation type
  dataAosDelay?: string; // Optional AOS delay
}

const Card: React.FC<CardProps> = ({
  image,
  title,
  description,
  gradient = "default",
  dataAos, // Receive the optional data-aos prop
  dataAosDelay, // Receive the optional data-aos-delay prop
}) => {
  // Determine the gradient and image style based on the prop
  const gradientClass =
    gradient === "alternative"
      ? "bg-gradient-to-b from-[#3fbff2] via-[#705EF9] to-[#9318FE]"
      : "bg-gradient-to-b from-[#c81ae0] to-[#6d41dd]";
  const imageStyle = gradient === "alternative" ? "object-contain" : "object-cover";

  return (
    <div
      className={`${gradientClass} rounded-lg shadow-lg p-4 text-center`}
      data-aos={dataAos} // Apply data-aos if provided
      data-aos-delay={dataAosDelay} // Apply data-aos-delay if provided
    >
      {/* Conditional Title */}
      <img
        src={image}
        className={`w-full h-32 sm:h-40 rounded-md mb-4 ${imageStyle}`}
        alt={title || "Card visual"}
      />
      {title && <h3 className="text-white text-lg font-semibold mb-4">{title}</h3>}
      <p className="text-purple-200 text-sm mt-2">{description}</p>
    </div>
  );
};

export default Card;
